import { render, staticRenderFns } from "./AbsenceRequest.vue?vue&type=template&id=666d6410"
import script from "./AbsenceRequest.vue?vue&type=script&lang=js"
export * from "./AbsenceRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports